var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { "tile is-parent": _vm.isTiled } }, [
    _c("article", { class: { "tile is-child box": _vm.isTiled } }, [
      _vm.isTiled
        ? _c("p", { staticClass: "title" }, [_vm._v("Remarks")])
        : _vm._e(),
      _c("div", { staticClass: "field is-horizontal" }, [
        _vm._m(0),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.remarks.remarks,
                    expression: "remarks.remarks",
                  },
                ],
                staticClass: "textarea",
                domProps: { value: _vm.remarks.remarks },
                on: {
                  change: function ($event) {
                    _vm.remarks.isDirty = true
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.remarks, "remarks", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-label is-normal" }),
        _c("div", { staticClass: "field-body" }, [
          _c("p", { staticClass: "control" }, [
            _c(
              "a",
              {
                staticClass: "button is-primary",
                on: { click: _vm.showRecurringRemark },
              },
              [_vm._m(1), _c("span", [_vm._v(" Recurring Remarks")])]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "field is-horizontal" }, [
        _vm._m(2),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field is-narrow" }, [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.remarks.isAlert,
                    expression: "entity.remarks.isAlert",
                  },
                ],
                staticClass: "switch is-rounded",
                attrs: { id: "alert", name: "alert", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.entity.remarks.isAlert)
                    ? _vm._i(_vm.entity.remarks.isAlert, null) > -1
                    : _vm.entity.remarks.isAlert,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.entity.remarks.isAlert,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.entity.remarks,
                            "isAlert",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.entity.remarks,
                            "isAlert",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.entity.remarks, "isAlert", $$c)
                    }
                  },
                },
              }),
              _c("label", { attrs: { for: "alert" } }),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Contents")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-repeat" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Alert?")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }